// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__8hO5x"};